import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Section } from 'src/app/models/obs/section';
import { Subsection } from 'src/app/models/obs/subsection';
import { Graphic } from 'src/app/models/obs/graphic';
import { SectionService } from 'src/app/services/obs/section.service';
import { Tier3Service } from 'src/app/services/obs/tier3.service';
import { GraphicService } from 'src/app/services/obs/graphic.service';
import { SubsectionService } from 'src/app/services/obs/subsection.service';
import { urlData, urlEndPoint } from 'src/app/common';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import * as mammoth from 'mammoth/mammoth.browser';
import { Tier3 } from 'src/app/models/obs/tier3';
import { Biblio } from 'src/app/models/obs/biblio';
import { BiblioService } from 'src/app/services/obs/biblio.service';
import { EventtypeService } from 'src/app/services/obs/eventtype.service';
import { EventType } from 'src/app/models/obs/eventtype';
/* import Quill from 'quill';
import ImageResize from 'quill-image-resize'; */
import 'src/app/components/util/quill-config/iframe-blot';
import { UtilLogService } from 'src/app/services/util/util-log.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { elementAt, firstValueFrom } from 'rxjs';
/* Quill.register('modules/imageResize', ImageResize); */

const FIGURE_REGEX = /^(Figura|Cuadro|Tabla|Fuente)\s+\d+\./;
const FIGURE_WITH_TITLE_REGEX = /^((Figura|Cuadro|Tabla|Fuente)\s+\d+\.\s*)(.*)/;
const NOTE_REGEX = /^(Nota[.:,]|Nota técnica[.:,]|Fuente[.:,])/;
const NOTE_WITH_CONTENT_REGEX = /^(Nota[.:,]|Nota técnica[.:,]|Fuente[.:,])\s*(.*)/;
const FIGURE_OR_NOTE_REGEX = /^(Figura|Cuadro|Tabla|Fuente)\s+\d+\.|^(Nota[.:,]|Nota técnica[.:,]|Fuente[.:,])/;
const REFERENCE_TERMS = ['Referencias', 'Bibliografía', 'Literatura', 'Fuentes', 'Citas'];
const REFERENCE_REGEX = new RegExp(`^(${REFERENCE_TERMS.join('|')})$`, 'i');

@Component({
  selector: 'app-admsheet-form',
  templateUrl: './admsheet-form.component.html',
  styleUrls: ['./admsheet-form.component.scss']
})
export class AdmsheetFormComponent implements OnInit {
  form: FormGroup;
  htmlContent: any;
  URL: string = urlEndPoint;

  t3: Tier3 = {};
  sections: Section[] = [];
  subsections: Subsection[] = [];
  graphics: Graphic[] = [];
  biblios: Biblio[] = [];
  biblio: Biblio[] = [];
  eventType: EventType = {};
  updateReferencesFlag: boolean = false;

  sectionsEdit: Section[] = [];
  subsectionsEdit: Subsection[] = [];
  graphicsEdit: Graphic[] = [];
  bibliosEdit: Biblio[] = [];
  fileName: string = '';
  idtier3Selected: number = null;
  isSaving: boolean = false;
  editorUser: string = null;

  isBlockedTier3: boolean = false;

  modulesQuill = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'header': 1 }, { 'header': 2 }],
      ['clean'],
      ['link', 'image', 'iframe']
    ],
    /*     imageResize: {
          modules: ['Resize', 'DisplaySize', 'Toolbar']
        } */
  };

  constructor(
    private tokenStorareService: TokenStorageService,
    private utilLogservice: UtilLogService,
    private biblioS: BiblioService,
    private secS: SectionService,
    private subS: SubsectionService,
    private graphS: GraphicService,
    private tier3: Tier3Service,
    private evt: EventtypeService,
    private activedRoute: ActivatedRoute,
    private route: Router,
    private uploadS: UploadfileService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.idtier3Selected = params['idtier3'];
    this.createForm();
    this.loadData(params['idtier3']);
    this.editorUser = this.tokenStorareService.getUser().nombre;
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      idtier3: [null],
      content: [],
      status: [true]
    });
  }
  /* Seccion de metodos para la obtencion de datos DB */
  /* 1. Lo primero es traer cada componente de la ficha desde la base de datos */
  /* ---------------------------------------------------------------------------- */
  loadData(id: number) {
    this.getTier3(id)
      .then(() => this.getEventtype(this.t3.idtier1))
      .then(() => this.getSec4t3(id))
      .then(() => this.getGraph4t3(id))
      .then(() => this.loadSubsections())
      .catch(err => {
        console.error("Error al cargar los datos completos:", err);
      });
    this.getReferenceBiblio(id);
  }

  getReferenceBiblio(id: any) {
    this.biblioS.getbyt3editor(id).subscribe(
      res => {
        this.biblio = res['data'];
        this.biblios = res['data'];
      },
      err => {
        console.log(err);
      }
    );
  }

  getTier3(id: number) {
    return new Promise((resolve, reject) => {
      this.tier3.getOne(id).subscribe(
        res => {
          this.t3 = res['data'] || {};
          resolve(null);
        },
        err => {
          console.error("Error al cargar ficha: ", err);
          reject(err);
        }
      );
    });
  }

  getEventtype(id: number) {
    return new Promise((resolve, reject) => {
      this.evt.getEventType(id).subscribe(
        res => {
          this.eventType = res['data'] || {};
          resolve(null);
        },
        err => {
          console.error("Error al cargar ficha: ", err);
          reject(err);
        }
      );
    });
  }

  getSec4t3(id: number) {
    return new Promise((resolve, reject) => {
      this.secS.get4T3(id).subscribe(
        res => {
          this.sections = res['data'];
          resolve(null);
        },
        err => {
          console.error("Error al cargar secciones: ", err);
          reject(err);
        }
      );
    });
  }

  getGraph4t3(id: number) {
    return new Promise((resolve, reject) => {
      this.graphS.getGr4T3(id).subscribe(
        res => {
          this.graphics = res['data'];
          resolve(null);
        },
        err => {
          console.error("Error al cargar gráficos: ", err);
          reject(err);
        }
      );
    });
  }

  getSubsec4Idsec(idSection: number) {
    return new Promise((resolve, reject) => {
      this.subS.get4sec(idSection.toString()).subscribe(
        res => {
          this.subsections.push(...res['data']);
          resolve(null);
        },
        err => {
          console.error("Error al cargar subsecciones:", err);
          reject(err);
        }
      );
    });
  }

  loadSubsections() {
    this.subsections = [];
    const requests = this.sections.map(section => this.getSubsec4Idsec(section.id));
    Promise.all(requests)
      .then(() => { this.updateEditorContent(); })
      .catch(err => { console.error("Error al cargar subsecciones:", err); });
  }
  /* 2. Constuimos la ficha segun el orden de cada elemento */
  /* ---------------------------------------------------------------------------- */
  //metodo para cargar la informacion inicial de los arreglos del servidor al editor
  updateEditorContent() {
    const allContent = this.sections.filter(section => section.status).map((section, sectionIndex) => {
      let sectionContent = section.title ? `<h1>${section.title}</h1>` : '';

      const relatedSubsections = this.subsections
        .filter(sub => sub.idsection === section.id && sub.status)
        .sort((a, b) => a.order - b.order);

      relatedSubsections.forEach(subsection => {
        if (subsection.title) sectionContent += `<h2>${subsection.title}</h2>`;
        let content = subsection.content || '';
        content = this.closeUnclosedBTags(content);
        sectionContent += `<p>${content || ''}</p><br>`;

        const relatedGraphics = this.graphics
          .filter(graphic => graphic.status && graphic.order === subsection.order);

        relatedGraphics.forEach(graphic => {
          sectionContent += this.getGraphicContent(graphic);
        });
      });
      return sectionContent;
    })
      .join('');

    const referencesContent = this.getReferencesContent();
    const finalContent = allContent + referencesContent;

    this.form.get('content').setValue(finalContent);
  }
  // metodo para corregir etiquetas <b> mal cerradas y poner <strong>
  closeUnclosedBTags(content: string): string {
    let openTag = false;
    return content.replace(/<b>/g, (match) => {
      if (openTag) {
        openTag = false;
        return '</strong>';
      } else {
        openTag = true;
        return '<strong>';
      }
    });
  }
  //apoyo pata la carga de los arreglos inciales al editor
  getGraphicContent(graphic: Graphic) {
    let content = '';
    if (graphic.idgraphictype === 12) {
      const iframeMatches = graphic.externalframe.match(/<iframe[^>]*>.*?<\/iframe>/g);
      if (iframeMatches) {
        iframeMatches.forEach(iframe => {
          if (iframe.includes('style="') && iframe.match(/height:\s*(\d+px|\d+%|auto)/)) {
            const modifiedIframe = iframe.replace(/(style="[^"]*")/, (match) => {
              const heightMatch = match.match(/height:\s*(\d+px|\d+%|auto)/);
              const widthMatch = match.match(/width:\s*(\d+px|\d+%)/);

              let height = heightMatch ? heightMatch[1] : 'auto';
              let width = '100%';

              return match.replace(/style="[^"]*"/, `height="${height}" width="${width}"`);
            });
            content += modifiedIframe + '<br>';
          } else {
            content += iframe + '<br>';
          }
        });
      }
    } else if (graphic.idgraphictype === 10) {
      const imageUrl = `${this.URL}${graphic.urldata || ''}`;
      const cleanTitle = (graphic.title || '').replace(/<a[^>]*>(.*?)<\/a>/g, '').replace(/\[.*?\]/g, '').replace(/,\s*/g, '').trim();
      content += `<img src="${imageUrl}" alt="${cleanTitle || ''}"><br>`;
    }
    if (graphic.numeration) {
      content += `<p>${graphic.numeration} ${graphic.title || ''}</p>`;
    }
    if (graphic.note) {
      content += `<p>${graphic.note}</p><br>`;
    }
    return content;
  }
  //apoyo pata la carga de los arreglos inciales de referencias al editor
  getReferencesContent(): string {
    if (!this.biblio || this.biblio.length === 0) return '';
    let referenceTitle = REFERENCE_TERMS.find(term =>
      Array.from(document.querySelectorAll('h1, h2, h3')).some(el => REFERENCE_REGEX.test(el.textContent || ''))
    ) || REFERENCE_TERMS[0];
    let referencesContent = `<h1>${referenceTitle}</h1></br><ol>`;

    this.biblio.forEach(ref => {
      referencesContent += `<li>${ref.content}</li>`;
    });
    referencesContent += `</ol>`;
    return referencesContent;
  }
  /*   3. Cargamos o capturamos la informacion que modificamos en el editor a los arreglos */
  //Metodo para cargar la informacion del editor a los arreglos section, subsection y graphics
  loadContentToArrays() {
    this.sectionsEdit = [];
    this.subsectionsEdit = [];
    this.graphicsEdit = [];
    this.bibliosEdit = [];
    this.sectionsEdit.push({
      id: null,
      idtier3: this.idtier3Selected,
      order: 1,
      title: '',
      status: true
    });

    const prevContent = this.form.get('content').value;
    const editorContent = this.cleanHtmlContent(prevContent);
    let hasAtLeastOneSection = false; // Bandera para indicar si ya se enconto una seccion valid
    // parseamos el contenido del quill
    const parser = new DOMParser();
    const doc = parser.parseFromString(editorContent, 'text/html');
    const bodyElement = doc.body;
    let sectionIndex = 0; // Contador para secciones
    let currentGraphic: any = null; // Objeto grafico temporal; lo usamos para cuando tengamos Objects Graphics con mas de un iframe o img. mientras vamos recorreindo cada elemento del dom aca vamos capturando los lementos de un grafico.
    let pendingH2Title: string | null = null; // Variable para alamcenar los titulos de secciones hasta encontrar el proximo parrafo en caso de existir muchos h2.

    if (bodyElement.innerHTML === "" || bodyElement.innerHTML === "null") {
      this.sectionsEdit[0].title = '';
    }

    // Aca esta la sufridera tenemos que mapear todo el DOM de QUILL en busqueda de cada etiqueta
    Array.from(bodyElement.children).forEach((element) => {
      if (element.nodeType === Node.ELEMENT_NODE) {
        const tagName = element.tagName.toLowerCase();
        const paragraphText = element.textContent.trim() || '';
        const iframeRegex = /<iframe.*?<\/iframe>/gi;

        // Procesar  h1 como titulo secciones
        if (tagName === 'h1' && !REFERENCE_REGEX.test(element.innerHTML)) {
          if (!hasAtLeastOneSection) {
            // Si no hay secciones usamos la seccion por defecto, esto para asegurar que siempre tengamos como minimo una seccion, importante!!!
            this.sectionsEdit[0].title = element.textContent.trim(); // Aca sobreescribirmos el titulo por defecto
            hasAtLeastOneSection = true; // Marcamos que ahora tenemos al menos una seccion
            this.sectionsEdit[0].order = sectionIndex; // Asignar el order del primer h1
          } else {
            // Si ya hay una seccion agregamos una nueva
            this.processSection(element as HTMLElement, sectionIndex);
          }
          // Si hay un grafico activo loo empujamos al arreglo antes de empezar una nueva seccion
          if (currentGraphic) {
            this.graphicsEdit.push(currentGraphic);
            currentGraphic = null; // Reiniciar el grafico activo
          }
          sectionIndex++; // Incrementar el indice para nuevas secciones
        }

        // Procesar h2 como titulo de subsecciones oooooo titulos en niveles. ejem 1.1. titulo, 1.1.1. titulo 1.1.1.1. titulo
        else if (tagName === 'h2' && element.innerHTML && !REFERENCE_REGEX.test(element.innerHTML)) {
          // Verificar si el siguiente elemento es un espacio en blanco
          const nextElement = element.nextElementSibling;

          if (pendingH2Title) {
            this.subsectionsEdit.push({
              id: null,
              idsection: sectionIndex,
              order: this.subsectionsEdit.length + 1,
              title: pendingH2Title,
              content: '', // Subsection vacia; osea es un titulo na mas 
              status: true
            });
            pendingH2Title = null;
          } else if (nextElement && (nextElement.tagName.toLowerCase() === 'p' && nextElement.innerHTML === '<br>' || nextElement.tagName.toLowerCase() === 'br')) {
            this.subsectionsEdit.push({
              id: null,
              idsection: sectionIndex,
              order: this.subsectionsEdit.length + 1,
              title: element.textContent.trim(),
              content: '', // Subsection vacia; osea es un titulo na mas 
              status: true
            });
          } else pendingH2Title = element.textContent.trim();
        }

        // Procesar parrafos como subsecciones y filtrar otro contenido que peude estar dentro de un p.
        else if (tagName === 'p' && element.innerHTML && !element.querySelector('br') && !element.querySelector('img') && !element.querySelector('iframe') && !element.querySelector('ol') && !element.querySelector('li') && !iframeRegex.test(paragraphText) && !paragraphText.includes('</script>')) {
          currentGraphic = this.processParagraph(element as HTMLElement, sectionIndex, currentGraphic, pendingH2Title);
          pendingH2Title = null;
          // Obtener el texto del parrafo
          const paragraphText = element.textContent.trim();
          const paragraphHTML = element.innerHTML.trim();
          // Verificar si el parrafo contiene una numeracion de figura ejmp Figura 1.
          if (FIGURE_REGEX.test(paragraphText)) {
            // Si es una figura, extraer numeracion y titulo
            const figureMatch = paragraphHTML.match(FIGURE_WITH_TITLE_REGEX);
            if (figureMatch) {
              const [_, numeration, type, title] = figureMatch;
              if (!currentGraphic) {
                // Inicializaremos currentGrapic si esta undefined osea sino vuelve nada de processParagraph
                currentGraphic = {
                  id: null,
                  idtier3: this.idtier3Selected,
                  idgraphictype: 10,
                  numeration: numeration.trim(),
                  title: title ? title.trim() : null,
                  note: null, // Inicializa la nota aqui
                  externalframe: null,
                  order: this.subsectionsEdit.length, // Asignar el orden
                  status: true
                };
              } else {
                // Actualiza el gráfico existente con la nueva figura
                currentGraphic.numeration = numeration.trim();
                currentGraphic.title = title ? title.trim() : null;
              }
            }
          }
          // Verificar si el parrafo contiene una notam de figurq ejemp Nota. o Nota:
          else if (NOTE_REGEX.test(paragraphText)) {
            if (currentGraphic) {
              // Extraer la nota y agregarla al gráfico
              const noteMatch = paragraphHTML.match(NOTE_WITH_CONTENT_REGEX);
              currentGraphic.note = noteMatch ? noteMatch[0].trim() : ''; // Establecer la nota
              // Agregar el graphic despues de haber establecido la nota
              this.graphicsEdit.push(currentGraphic);
              currentGraphic = null; // Reiniciar el grafico activo
            }
          }
        }

        // Procesar iframes eee imagenes como graficos
        else if (tagName === 'iframe' || tagName === 'img' || (tagName === 'p' && (element.querySelector('img') || element.querySelector('iframe') || paragraphText.match(iframeRegex)))) {
          // Solo si es un iframe, se puede agregar a currentGraphic
          if (tagName === 'iframe' || (tagName === 'p' && (element.querySelector('iframe') || paragraphText.match(iframeRegex)))) {
            if (!currentGraphic) {
              currentGraphic = {
                id: null,
                idtier3: this.idtier3Selected,
                idgraphictype: 12,
                numeration: null,
                title: null,
                note: null,
                urldata: null,
                externalframe: '',
                isresponsive: true,
                order: this.subsectionsEdit.length, // Asignar el orden. que basicamente es el tamaño del arreglo
                status: true
              };
            }
            // si el elemento es un <iframe o un <p> que contiene un <iframe>
            let iframeElement = tagName === 'iframe' ? element : element.querySelector('iframe');
            let iframeContent = iframeElement ? iframeElement.outerHTML : '';

            if (iframeContent) {
              currentGraphic.externalframe += this.buildIFrameTemplate(iframeElement as HTMLElement);
            } else {
              iframeContent = iframeContent.replace(
                '<iframe class="ql-video ql-align-justify"',
                '<iframe scrolling="no" frameborder="0" style="border: none;"'
              );
              currentGraphic.externalframe += paragraphText;
            }
          }

          // Solo si es un img, se puede agregar a currentGraphic
          else if (tagName === 'img' || (tagName === 'p' && element.querySelector('img'))) {
            if (!currentGraphic) {
              currentGraphic = {
                id: null,
                idtier3: this.idtier3Selected,
                idgraphictype: 10,
                numeration: null,
                title: null,
                note: null,
                urldata: this.cleanUrl(tagName === 'img' ? element.getAttribute('src') : element.querySelector('img').getAttribute('src')),
                externalframe: null,
                order: this.subsectionsEdit.length, // Asignar el orden
                status: true
              };
            }
          }
        }
        // Procesar referencias bibliográficas
        else if (tagName === 'ol' || (tagName === 'p' && element.querySelector('ol'))) {
          const referencesList = element.querySelectorAll('li');
          referencesList.forEach((li: any) => {
            const referenceText = li.textContent.trim();
            if (referenceText) {
              const urlMatch = referenceText.match(/https?:\/\/[^\s]+/);
              const urlsource = urlMatch ? urlMatch[0].replace(/\.$/, '') : null;
              this.bibliosEdit.push({
                id: null,
                idtier3: this.idtier3Selected,
                order: this.bibliosEdit.length + 1,
                content: referenceText,
                urlsource: urlsource,
                status: true
              });
            }
          });
        }

        else if (tagName === 'ul' || (tagName === 'p' && element.querySelector('ul'))) {
          const listItems = element.querySelectorAll('li');
          listItems.forEach((li, index) => {
            currentGraphic = this.processParagraph(li as HTMLElement, sectionIndex, currentGraphic, pendingH2Title);
          });
        }

      }
    });

    // Si hay un gráfico activo al final, se agrega a graphicsEdit :)
    if (currentGraphic) {
      this.graphicsEdit.push(currentGraphic);
    }
  }
  // Procesar secciones <H1>
  processSection(element: HTMLElement, index: number) {
    const sectionText = element.textContent.trim() || '';
    this.sectionsEdit.push({
      id: null,
      idtier3: this.idtier3Selected,
      order: index,
      title: sectionText || null,
      status: true
    });
  }
  // Procesar <p> como subsecciones y de paso revisar si existen figura y nota para mantenerlos en el objeto temporal hasta que se encuentre todos sus elementos.
  processParagraph(element: HTMLElement, sectionIndex: number, currentGraphic: any, titlep: any) {
    const paragraphText = element.textContent.trim() || '';
    let paragraphHTML = element.innerHTML.trim() || '';
    paragraphHTML = paragraphHTML.replace(/<\/?span[^>]*>/g, '');
    if (element.tagName === 'LI') paragraphHTML = `<ul>${element.outerHTML.trim()}</ul>`;
    // Aca alamcenamos de una vez aquellos elementos que son parrafos.
    if ((paragraphText || titlep) && !FIGURE_OR_NOTE_REGEX.test(paragraphText)) {
      this.subsectionsEdit.push({
        id: null,
        idsection: sectionIndex > 0 ? sectionIndex : sectionIndex + 1,
        order: this.subsectionsEdit.length + 1,
        title: titlep || null,
        content: paragraphHTML,
        status: true
      });
    }
    // cuurent graphic es un objeto temporal en que estamos alamcenando los elemntos que los componen.
    else if (FIGURE_REGEX.test(paragraphText)) {
      const figureMatch = paragraphHTML.match(FIGURE_WITH_TITLE_REGEX);
      if (figureMatch) {
        const [_, numeration, , titleHTML] = figureMatch;
        if (currentGraphic) {
          currentGraphic.numeration = numeration.trim();
          currentGraphic.title = titleHTML ? titleHTML.trim() : null;
        }
      }
    }
    else if (NOTE_REGEX.test(paragraphText)) {
      const noteMatch = paragraphHTML.match(NOTE_WITH_CONTENT_REGEX);
      if (noteMatch) {
        const [_, , noteHTML] = noteMatch;
        if (currentGraphic) {
          currentGraphic.note = noteHTML ? noteHTML.trim() : null;
        }
      }
    }
    return currentGraphic;
  }
  /*   4. Procedemos a guardar la informacion componete por componete en orden */
  /*  los metodos merge_ crean los objetos de cada componente haciendo comparacion entre los arreglo de DB y los arreglos que obtenemos despues de editar en el editor */
  /*  Cuanod ya se tiene los arreglo merge estos son los que iran a los metodos de guardado en DB */
  /* ---------------------------------------------------------------------------- */
  // Gurdamos en forma escalonada cada section,subsection,graphics y biblio
  async save() {
    this.isSaving = true; // Indicar que el guardado ha comenzado
    try {
      // 0. Verificar si la ficha no está bloqueada para su edición
      const isBlocked = await this.getIsBlockedTier3(this.idtier3Selected);
      if (isBlocked) {
        this.isSaving = false;
        window.alert('El documento ha sido publicado y ya no se pueden realizar ediciones directamente. Si necesitas hacer cambios, regresa a la lista de fichas y utiliza la opción "Editar" para habilitar el formulario nuevamente.');
        return; // Detenemos el proceso de guardado
      }
      // 1. Cargamos todo el contenido en los arreglos ...Edit
      this.loadContentToArrays();

      // 2. Realizamos el merge de las secciones
      const sectionsToSave = this.mergeSectionsData(this.sections, this.sectionsEdit);

      // 2.1. Realizamos el guardado de las secciones
      const updatedSections = await this.createSections(sectionsToSave);

      // 2.2. Separar secciones en creación y edición
      this.handleSectionsLog(updatedSections);

      // 3. Realizamos el merge de las subsecciones y enviamos los ids de las secciones ya guardadas
      const subsectionsToSave = this.mergeSubsectionsData(this.subsections, this.subsectionsEdit, updatedSections);

      // 3.1. Guardamos las subsecciones
      const updatedSubsections = await this.createSubsections(subsectionsToSave);

      // 3.2. Separar subsecciones en creación y edición
      this.handleSubsectionsLog(updatedSubsections);

      // 4. Hacemos el merge de los gráficos
      const graphicsToSave = await this.mergeGraphicsData(this.graphics, this.graphicsEdit);

      // 4.1. Enviamos a guardar los gráficos con las imágenes almacenadas en uploads
      const updatedGraphics = await this.createGraphics(graphicsToSave);

      // 4.2. Separar graficos en creación y edición
      this.handleGraphicsLog(updatedGraphics);

      // 5. Hacemos el merge de los ref bibliograficas
      const refBiblioToSave = await this.mergeBibliosData(this.biblios, this.bibliosEdit);

      // 5.1. Enviamos a guardar los ref biblio
      const updatedBiblios = await this.createBiblios(refBiblioToSave);

      // 5.2. Separar referencias bibliograficas en creación y edición
      this.handleBibliosLog(updatedBiblios);

      // 5. Realizamos el refresh del editor para visualizar los cambios almacenados
      this.loadData(this.idtier3Selected);
    } catch (err) {
      console.error('Error al guardar secciones, subsecciones, gráficos o ref bibliograficas:', err);
      window.alert(err);
    } finally {
      this.isSaving = false; // Indicar que el guardado ha finalizado
    }
  }

  //Metodo para hacer el match entre el arreglo inicial y final para secciones
  mergeSectionsData(initialSections: Section[], editedSections: Section[]): Section[] {
    const mergedSections: (Section & { flag?: string })[] = [];// para no afectar section insertamos momentaneamente el flag
    // Proteger la seccion por defecto: siempre debe existir una seccion
    if (editedSections.length === 0) {
      // Si no hay ediciones, mantener la seccion inicial
      mergedSections.push({ ...initialSections[0], status: true });
      return mergedSections;
    }
    // Recorrer los arreglos y realizar la fuuuusion
    editedSections.forEach((editedSection, index) => {
      if (index < initialSections.length) {
        // Caso de edicion: comparar con la seccion correspondiente
        const originalSection = initialSections[index];
        const normalize = (value) => value || "";
        const isModified =
          normalize(originalSection.title) !== normalize(editedSection.title) ||
          originalSection.order !== editedSection.order;
        if (isModified) {
          mergedSections.push({
            ...originalSection,
            title: editedSection.title,
            order: editedSection.order,
            touchedBy: this.editorUser,
            status: true, // Mantener activa
          });
        } else {
          mergedSections.push({
            ...originalSection,
            title: editedSection.title,
            order: editedSection.order,
            status: true,
            flag: 'unchanged',
          });
        }

      } else {
        // Caso de adicion: nueva seccion
        mergedSections.push({
          id: null /* initialSections.length + index + 1 */, // Generar un nuevo id
          idtier3: this.idtier3Selected,
          title: editedSection.title,
          order: editedSection.order,
          touchedBy: this.editorUser,
          status: true,
        });
      }
    });

    // Marcar como inactivas las secciones no presentes en editedSections (excepto la primera). Eston lo hacemos para simular la eliminacion de contenido , estamos usando la eliminacion logico mas no fisica para poder tener historial
    for (let i = editedSections.length; i < initialSections.length; i++) {
      if (i === 0) {
        // No se permite eliminar la primera seccion, mantenerla activa
        mergedSections.push({ ...initialSections[i], status: true });
      } else {
        // Las otras secciones se marcan como inactivas
        mergedSections.push({ ...initialSections[i], status: false });
      }
    }
    /* console.log("tenemos el arreglo que guardaremos : ", mergedSections); */
    return mergedSections;
  }
  //Metodo para hacer el match entre el arreglo inicial y final para subsecciones
  mergeSubsectionsData(initialSubsections: Subsection[], editedSubsections: Subsection[], updatedSections: Section[]): Subsection[] {
    const mergedSubsections: (Subsection & { flag?: string })[] = [];

    editedSubsections.forEach((editedSubsection, index) => {
      const correspondingSection = updatedSections.find((section, sectionIndex) =>
        sectionIndex + 1 == editedSubsection.idsection
      );

      if (index < initialSubsections.length) {
        // Caso de edicion: tomar la subseccion inicial y aplicar cambios
        const originalSubsection = initialSubsections[index];
        const normalize = (value) => (value || "").trim();

        // limpiar title
        const decodeHTMLEntities = (html) => {
          const element = document.createElement("textarea");
          element.innerHTML = html;
          return element.value;
        };

        // limpiar content
        const normalizeHTML = (html) => {
          if (!html) return "";
          const decodedHTML = decodeHTMLEntities(html);
          const cleanedHTML = decodedHTML.replace(/<a[^>]*\srel="[^"]*"[^>]*>/g, (match) =>
            match.replace(/\srel="[^"]*"/, "")
          );
          return cleanedHTML.replace(/\s+/g, " ").trim();
        };

        const isModified =
          originalSubsection.idsection !== correspondingSection.id ||
          normalize(originalSubsection.title) !== normalize(editedSubsection.title) ||
          normalizeHTML(originalSubsection.content) !== normalizeHTML(editedSubsection.content) ||
          originalSubsection.order !== editedSubsection.order;

        if (isModified) {
          mergedSubsections.push({
            ...originalSubsection,
            title: editedSubsection.title,
            content: editedSubsection.content,
            order: editedSubsection.order,
            idsection: correspondingSection ? correspondingSection.id : editedSubsection.idsection,
            touchedBy: this.editorUser,
            status: true, // Mantener activa
          });
        }
        else {
          mergedSubsections.push({
            ...originalSubsection,
            title: editedSubsection.title,
            content: editedSubsection.content,
            order: editedSubsection.order,
            idsection: correspondingSection ? correspondingSection.id : editedSubsection.idsection,
            status: true, // Mantener activa
            flag: 'unchanged',
          });
        }
      } else {
        // Caso de adicion: nueva subseccion
        mergedSubsections.push({
          id: null,
          idsection: correspondingSection ? correspondingSection.id : editedSubsection.idsection,
          order: editedSubsection.order,
          title: editedSubsection.title,
          content: editedSubsection.content,
          touchedBy: this.editorUser,
          status: true,
        });
      }
    });
    // Marcar como inactivas las subsecciones no presentes en editedSubsections, ya se sabe para que!
    for (let i = editedSubsections.length; i < initialSubsections.length; i++) {
      mergedSubsections.push({ ...initialSubsections[i], status: false });
    }
    /*     console.log("Subsecciones a guardar:", mergedSubsections); */
    return mergedSubsections;
  }
  //Metodo para hacer el match entre el arreglo inicial y final para graficos
  async mergeGraphicsData(initialGraphics: Graphic[], editedGraphics: Graphic[]): Promise<Graphic[]> {
    const mergedGraphics: (Graphic & { flag?: string })[] = [];
    // Proceso de fusin de los graficos edtitados con los graficos originales
    for (let i = 0; i < editedGraphics.length; i++) {
      const editedGraphic = editedGraphics[i];
      if (i < initialGraphics.length) {
        // Edicion de un gráfico existente
        const originalGraphic = initialGraphics[i];
        if (editedGraphic.idgraphictype == 10 && editedGraphic.urldata && editedGraphic.urldata.startsWith("data:image")) {
          // Caso de una imagen en base64: subir la imagen y actualizar `urldata`
          try {
            let extension = this.extractImageData(editedGraphic.urldata).extension;
            const uploadedFilename = await this.uploadBase64Image(editedGraphic.urldata, `image_${Date.now()}.${extension}`);
            const normalize = (value) => value || "";
            const isModified =
              originalGraphic.idgraphictype !== editedGraphic.idgraphictype ||
              normalize(originalGraphic.title) !== normalize(editedGraphic.title) ||
              originalGraphic.numeration !== editedGraphic.numeration ||
              originalGraphic.note !== editedGraphic.note ||
              originalGraphic.urldata !== editedGraphic.urldata ||
              originalGraphic.order !== editedGraphic.order;

            if (isModified) {
              mergedGraphics.push({
                ...originalGraphic,
                idgraphictype: editedGraphic.idgraphictype,
                title: editedGraphic.title,
                numeration: editedGraphic.numeration,
                note: editedGraphic.note,
                urldata: `/uploads/${uploadedFilename}`,
                externalframe: '',
                isresponsive: editedGraphic.isresponsive,
                order: editedGraphic.order,
                touchedBy: this.editorUser,
                status: true,
              });
            } else {
              mergedGraphics.push({
                ...originalGraphic,
                flag: 'unchanged',
                status: true,
              });
            }
          } catch (err) {
            console.error("Error al subir la imagen:", err);
          }
        } else if (editedGraphic.idgraphictype == 12 && editedGraphic.externalframe) {
          // Caso de un iframe (Datawrapper): actualizar el campo `externalframe`
          const getIframeSrc = (iframe) => {
            if (!iframe) return "";
            const match = iframe.match(/src="([^"]*)"/);
            return match ? match[1].trim() : "";
          };
          const isModified =
            originalGraphic.idgraphictype !== editedGraphic.idgraphictype ||
            originalGraphic.title !== editedGraphic.title ||
            originalGraphic.numeration !== editedGraphic.numeration ||
            getIframeSrc(originalGraphic.externalframe) !== getIframeSrc(editedGraphic.externalframe) ||
            originalGraphic.note !== editedGraphic.note ||
            originalGraphic.order !== editedGraphic.order;

          if (isModified) {
            mergedGraphics.push({
              ...originalGraphic,
              idgraphictype: editedGraphic.idgraphictype,
              title: editedGraphic.title,
              numeration: editedGraphic.numeration,
              note: editedGraphic.note,
              urldata: '', // No se utiliza `urldata` para iframes
              externalframe: editedGraphic.externalframe,
              isresponsive: editedGraphic.isresponsive,
              order: editedGraphic.order,
              touchedBy: this.editorUser,
              status: true,
            });
          } else {
            mergedGraphics.push({
              ...originalGraphic,
              flag: 'unchanged',
              status: true,
            });
          }
        } else {
          // simplemente actualizar los datos, osea que ya existe informacion en el campo urldata
          const isModified =
            originalGraphic.idgraphictype !== editedGraphic.idgraphictype ||
            originalGraphic.title !== editedGraphic.title ||
            originalGraphic.numeration !== editedGraphic.numeration ||
            originalGraphic.urldata !== editedGraphic.urldata ||
            originalGraphic.note !== editedGraphic.note ||
            originalGraphic.order !== editedGraphic.order;

          if (isModified) {
            mergedGraphics.push({
              ...originalGraphic,
              idgraphictype: editedGraphic.idgraphictype,
              title: editedGraphic.title,
              numeration: editedGraphic.numeration,
              note: editedGraphic.note,
              urldata: editedGraphic.urldata ? editedGraphic.urldata : null,
              externalframe: editedGraphic.externalframe ? editedGraphic.externalframe : null,
              isresponsive: editedGraphic.isresponsive,
              order: editedGraphic.order,
              touchedBy: this.editorUser,
              status: true,
            });
          } else {
            mergedGraphics.push({
              ...originalGraphic,
              flag: 'unchanged',
              status: true,
            });
          }
        }
      } else {
        // Caso de adicion :nuevo graafico
        let newUrldata = editedGraphic.urldata;
        let newExternalframe = editedGraphic.externalframe;
        if (editedGraphic.idgraphictype === 10 && editedGraphic.urldata && editedGraphic.urldata.startsWith("data:image")) {
          // Si es una nueva imagen en Base64, subirla y actualizar `urldata`
          try {
            let extension = this.extractImageData(editedGraphic.urldata).extension;;
            const uploadedFilename = await this.uploadBase64Image(editedGraphic.urldata, `image_${Date.now()}.${extension}`);
            newUrldata = `/uploads/${uploadedFilename}`;
          } catch (err) {
            console.error("Error al subir la imagen:", err);
          }
        }

        // Agregar el nuevo gráfico al arreglo `mergedGraphics`
        mergedGraphics.push({
          id: null,
          idtier3: editedGraphic.idtier3,
          idgraphictype: editedGraphic.idgraphictype,
          numeration: editedGraphic.numeration,
          title: editedGraphic.title,
          note: editedGraphic.note,
          urldata: editedGraphic.idgraphictype === 10 ? newUrldata : '',
          externalframe: editedGraphic.idgraphictype === 12 ? newExternalframe : '',
          isresponsive: editedGraphic.isresponsive,
          order: editedGraphic.order,
          touchedBy: this.editorUser,
          status: true,
        });
      }

    }

    // Marcar como inactivos los graficos que no están en `editedGraphics`, para simulñar de nuvo la eliminacion logica
    for (let i = editedGraphics.length; i < initialGraphics.length; i++) {
      mergedGraphics.push({ ...initialGraphics[i], status: false });
    }
    return mergedGraphics;
  }
  //Metodo para hacer el match entre el arreglo inicial y final para referencias biblio
  mergeBibliosData(initialBiblios: Biblio[], editedBiblios: Biblio[]): Biblio[] {
    const mergedBiblios: (Biblio & { flag?: string })[] = [];
    // recorer los arreglos y realizar la fusin
    editedBiblios.forEach((editedBiblio, index) => {
      if (index < initialBiblios.length) {
        // caso de edicion: comparar con la referencia correspondiente
        const originalBiblio = initialBiblios[index];
        let urlsource = editedBiblio.urlsource !== null ? editedBiblio.urlsource : this.normalizeValue(originalBiblio.urlsource)
        const isModified =
          this.normalizeContentBiblio(originalBiblio.content) !== this.normalizeContentBiblio(editedBiblio.content) ||
          this.normalizeValue(originalBiblio.urlsource) !== urlsource ||
          originalBiblio.order !== editedBiblio.order;

        if (isModified) {
          mergedBiblios.push({
            ...originalBiblio,
            content: editedBiblio.content || originalBiblio.content,
            urlsource: editedBiblio.urlsource || originalBiblio.urlsource,
            order: editedBiblio.order,
            touchedBy: this.editorUser,
            status: true, // Mantener activa
          });
        } else {
          mergedBiblios.push({
            ...originalBiblio,
            flag: 'unchanged',
            status: true,
          });
        }
      } else {
        // Caso de adición: nueva referencia
        mergedBiblios.push({
          id: null, // Generar un nuevo id
          idtier3: this.idtier3Selected,
          content: editedBiblio.content,
          urlsource: editedBiblio.urlsource,
          order: editedBiblio.order,
          touchedBy: this.editorUser,
          status: true,
        });
      }
    });

    // Marcar como inactivas las referencias no presentes en editedBiblios
    for (let i = editedBiblios.length; i < initialBiblios.length; i++) {
      mergedBiblios.push({ ...initialBiblios[i], status: false });
    }
    return mergedBiblios;
  }
  /* Metodos  crear section DB */
  createSections(sections: Section[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.secS.createUpdateOnBlock(sections).subscribe(
        res => {
          const updatedSections = res.data;
          resolve(updatedSections);
        },
        err => reject('Error al guardar secciones: ' + err)
      );
    });
  }
  /* Metodos  crear subsection DB */
  createSubsections(subSections: Subsection[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.subS.createUpdateOnBlock(subSections).subscribe(
        res => {
          const updatedSubsections = res.data;
          resolve(updatedSubsections);
        },
        err => reject('Error al guardar subsecciones: ' + err)
      );
    });
  }
  /* Metodos  crear graphics DB */
  createGraphics(graphics: Graphic[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.graphS.createUpdateOnBlock(graphics).subscribe(
        res => {
          const updatedGraphics = res.data;
          resolve(updatedGraphics);
        },
        err => reject('Error al guardar gráficos: ' + err)
      );
    });
  }
  /* Metodos  crear bibliografias en DB */
  createBiblios(biblios: Biblio[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.biblioS.createUpdateOnBlock(biblios).subscribe(
        res => {
          const updatedBiblios = res.data;
          resolve(updatedBiblios);
        },
        err => reject('Error al guardar referencias bibliograficas: ' + err)
      );
    });
  }
  /* Metodos  almacenar imagen en carpeta upload */
  uploadBase64Image(base64: string, filename: string): Promise<string> {
    const file = this.convertBase64ToFile(base64, filename);
    let formData = new FormData();
    formData.append("uploads", file, file.name); // creamos el formatto que ura el api upload

    return new Promise((resolve, reject) => {
      this.uploadS.uploadFile(formData).subscribe(
        (res: any) => {
          if (res && res.filename) {
            resolve(res.filename);
          } else {
            reject("Error: El nombre del archivo no está presente en la respuesta.");
          }
        },
        (err) => {
          console.error("Error al cargar la imagen:", err);
          reject("Error al cargar la imagen: " + err);
        }
      );
    });
  }
  //El editor esta espeso por ello usamos un conversor de base64 para todas las imagenes.
  convertBase64ToFile(base64: string, filename: string): File {
    const arr = base64.split(',');
    const mime = arr[0].match(/:(.*?);/)[1]; // Extrae el tipo MIME
    const bstr = atob(arr[1]); // Decodifica la cadena Base64
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }
  //Este es auxiliar para extraer la extension del archivo que se esta subiendo
  private extractImageData(base64Image: string): { extension: string } | null {
    const matches = base64Image.match(/^data:(image\/.+);base64,(.+)$/);

    if (!matches) {
      console.error('Invalid base64 image data');
      alert('El archivo de imagen proporcionado no es válido.');
      return null;
    }

    const mimeType = matches[1];

    let extension = 'png'; // Valor por defecto
    switch (mimeType) {
      case 'image/jpeg':
        extension = 'jpg';
        break;
      case 'image/png':
        extension = 'png';
        break;
      case 'image/webp':
        extension = 'webp';
        break;
      case 'image/bmp':
        extension = 'bmp';
        break;
      case 'image/tiff':
        extension = 'tiff';
        break;
      default:
        console.warn('Formato de imagen no soportado:', mimeType);
        alert(`El formato de imagen ${mimeType} no es compatible. Por favor, sube una imagen en formato JPG, PNG, WebP, BMP o TIFF.`);
        return null;
    }
    return { extension };
  }
  // Auxiliar para limpiar la url.
  private cleanUrl(url: string): string {
    if (!url) return '';
    const prefix = this.URL;
    return url.startsWith(prefix) ? url.substring(prefix.length) : url;
  }
  //Cargamos el archivo word
  onFileChange(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.form.get('content').setValue('');
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const arrayBuffer = e.target.result;
        mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          .then((result) => {
            let html = result.value.replace(/<em>(.*?)<\/em>/g, '$1');
            html = this.processMammothContent(html);
            this.form.get('content').setValue(html);
          })
          .catch((err) => {
            console.error("Error convirtiendo el archivo:", err);
          });
      };
      reader.readAsArrayBuffer(file);
    } else {
      this.fileName = '';
    }
  }
  //Para acomodart lo que viene del word.
  processMammothContent(html: string): string {
    html = html.replace(/<p><\/p>/g, '');
    html = html.replace(/(<p>.*?<\/p>)(?=\s*\1)/g, '');
    html = html.replace(/<\/p>/g, (match, offset, original) => {
      const paragraphContent = original.slice(original.lastIndexOf('<p>', offset), offset);
      if (FIGURE_REGEX.test(paragraphContent)) {
        return '</p>';
      }
      if (NOTE_REGEX.test(paragraphContent)) {
        return '</p><br><br>';
      }
      return '</p><br>';
    });
    const referencesRegex = new RegExp(`<h1>(${REFERENCE_TERMS.join('|')})<\/h1>`, 'i');

    html = html.replace(
      new RegExp(`${referencesRegex.source}([\\s\\S]*?)(?=<h1>|$)`, 'i'),
      (match, title, content) => {
        const listItems = content
          .split(/<br>/)
          .filter(item => item.trim() !== '')
          .map((item, index, array) => {
            const referenceMatch = item.match(/<p>(\[\d+\])\s*<\/p>/);
            const textMatch = array[index + 1]?.match(/<p>(.*)<\/p>/);
            if (referenceMatch && textMatch) {
              return `<li>${referenceMatch[1]} ${textMatch[1].trim()}</li>`;
            }
            return '';
          })
          .filter(item => item !== '')
          .join('');
        return `<h1>${title}</h1><ol>${listItems}</ol>`;
      }
    );
    return html;
  }
  //Limpiar las referencias antes de cambiar a las nuevas referencias
  cleanLinksFromReferences(content: string): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    doc.body.querySelectorAll('a').forEach(link => {
      const linkText = link.textContent || '';
      link.replaceWith(document.createTextNode(linkText));
    });
    return doc.body.innerHTML;
  }
  //Actualizar el contenido de la ficha con hipervinculos de referencias
  updateReferences() {
    this.getReferenceBiblio(this.idtier3Selected);
    const content = this.form.get('content').value;
    const editorContent = this.cleanHtmlContent(content);
    const cleanedContent = this.cleanLinksFromReferences(editorContent);
    const updatedContent = this.updateReferencesLogic(cleanedContent, this.biblio);
    this.form.get('content').setValue(updatedContent);
  }
  //Buscar las referencias de bibliografias
  updateReferencesLogic(content: string, references: any[]): string {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');

    references.forEach(ref => {
      const regex = new RegExp(`\\[(\\d+(?:,\\s*\\d+)*)(?:,\\s*(p(?:ág|ag)?\\.?|p\\.)\\s*\\d+)?\\]`, 'gi');
      doc.body.querySelectorAll('*').forEach(node => {
        const isInReferencesSection = node.closest('.references');
        if (isInReferencesSection || node.nodeType !== Node.ELEMENT_NODE || node.tagName === 'A') {
          return;
        }
        Array.from(node.childNodes).forEach(child => {
          if (child.nodeType === Node.TEXT_NODE && regex.test(child.textContent || '')) {
            const matches = child.textContent.match(regex);

            if (matches) {
              let updatedText = child.textContent;
              matches.forEach(match => {
                const matchParts = match.slice(1, -1).split(',').map(part => part.trim());

                const linkedParts = matchParts.map(part => {
                  const numberMatch = part.match(/^(\d+)/);
                  const pageMatch = part.match(/(p(?:ág|ag)?\\.?|p\\.)\\s*\\d+/i);
                  const number = numberMatch ? numberMatch[0] : null;

                  if (number) {
                    let refForNumber = null;
                    for (const r of references) {
                      const match = r.content.match(/\[(\d+)\]/);
                      if (match) {
                        const contentNumber = parseInt(match[1], 10);
                        if (contentNumber === parseInt(number, 10)) {
                          refForNumber = r;
                          break;
                        }
                      }
                    }

                    if (refForNumber) {
                      const urlFromContentMatch = refForNumber.content ? refForNumber.content.match(/https?:\/\/[^\s]+/) : null;
                      let url = refForNumber.urlsource || (urlFromContentMatch ? urlFromContentMatch[0] : null);
                      if (url) {
                        url = url.replace(/\.$/, '');
                        return `<a href="${url}" target="_blank">${part}</a>`;
                      }
                    }
                  }
                  return part;
                });
                const linkedText = `[${linkedParts.join(', ')}]`;
                updatedText = updatedText.replace(match, linkedText);
              });
              const wrapper = document.createElement('span');
              wrapper.innerHTML = updatedText;
              Array.from(wrapper.childNodes).forEach(newChild => {
                child.parentNode.insertBefore(newChild, child);
              });
              child.remove();
            }
          }
        });
      });
    });
    return doc.body.innerHTML;
  }
  //Auxiliar para estandarizar la estrucura de los iframes
  buildIFrameTemplate(originalIframe: HTMLElement): string {
    const title = originalIframe.getAttribute('title') || '';
    const label = originalIframe.getAttribute('aria-label') || '';
    const id = originalIframe.getAttribute('id') || '';
    const src = originalIframe.getAttribute('src') || '';
    /*    const width = originalIframe.getAttribute('width') || '100%'; */
    const width = '100%';
    let height = originalIframe.getAttribute('height');

    const datawrapperScript = `<script type="text/javascript">!function(){"use strict";window.addEventListener("message",(function(a){if(void 0!==a.data["datawrapper-height"]){var e=document.querySelectorAll("iframe");for(var t in a.data["datawrapper-height"])for(var r=0;r<e.length;r++)if(e[r].contentWindow===a.source){var i=a.data["datawrapper-height"][t]+"px";e[r].style.height=i}}}))}();</script>`;

    return `<iframe title="${title}" aria-label="${label}" id="${id}" src="${src}" width="${width}" height="${height}" scrolling="no" frameborder="0" style="min-width: 100% !important; border: none;" allowfullscreen="true"></iframe>${datawrapperScript}`;
  }
  //Redireccionar a la lista respectiva
  cancel() {
    const routePath = `/adm/${this.eventType.name.split(' ')[0].toLowerCase()}/list/`;
    this.route.navigate([routePath]);
  }
  //Redireccionar a la lista respectiva
  goBackToVersionList() {
    const routePath = `/adm/${this.eventType.name.split(' ')[0].toLowerCase()}/list/`;
    this.route.navigate([routePath]);
  }
  //Este emtodo se usa para limpiar el dom de elementos creados por el quill que no nos sirven
  private cleanHtmlContent(html: string): string {
    if (!html) return '';

    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    let cleanedHtml = textarea.value;

    // Reemplazar específicamente algunas entidades HTML problemáticas
    cleanedHtml = cleanedHtml
      .replace(/&nbsp;/g, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&#39;/g, "'")
      .replace(/&apos;/g, "'")
      .replace(/&copy;/g, '©')
      .replace(/&reg;/g, '®')
      .replace(/&euro;/g, '€')
      .replace(/&mdash;/g, '—')
      .replace(/&ndash;/g, '–')
      .replace(/&lsquo;/g, '‘')
      .replace(/&rsquo;/g, '’')
      .replace(/&ldquo;/g, '“')
      .replace(/&rdquo;/g, '”')

    cleanedHtml = cleanedHtml.replace(/<p><br><\/p>/g, '').trim();
    cleanedHtml = cleanedHtml.replace(/\s+/g, ' ').trim();
    cleanedHtml = cleanedHtml.replace(/<img([^>]*)>/g, (match, attributes) => {
      // Filtrar solo los atributos permitidos
      const allowedAttributes = attributes.match(/(src|alt|width|height|title)="[^"]*"/g) || [];
      return `<img ${allowedAttributes.join(' ')}>`;
    });
    cleanedHtml = cleanedHtml.replace(/<iframe([^>]*)>/g, (match, attributes) => {
      const allowedAttributes = attributes.match(/(src|width|height|allowfullscreen|frameborder|style)="[^"]*"/g) || [];
      return `<iframe ${allowedAttributes.join(' ')}></iframe>`;
    });
    return cleanedHtml;
  }
  /* 5. REgistramos si hubieron cambios en los compoentes al guardar en DB*/
  //Manejo de los logs sections
  handleSectionsLog(updatedSections: Section[]): void {
    updatedSections.forEach(section => {
      if (section && section['flag'] == 'unchanged') return;
      const action = this.sections.some(s => s.id === section.id) ? 'edición' : 'creación';
      section.idtier3 = this.idtier3Selected;
      this.utilLogservice.createLog(section, action, 'section');
    });
  }
  //Manejo de los logs subsextions
  handleSubsectionsLog(updatedSubsections: Subsection[]): void {
    updatedSubsections.forEach(subsection => {
      if (subsection && subsection['flag'] == 'unchanged') return;
      const action = this.subsections.some(s => s.id === subsection.id) ? 'edición' : 'creación';
      const logData = { ...subsection, idtier3: subsection.idsection };
      this.utilLogservice.createLog(logData, action, 'subseccion');
    });
  }
  //Manejo de los logs graficos
  handleGraphicsLog(updatedGraphics: Graphic[]): void {
    updatedGraphics.forEach(graphic => {
      if (graphic && graphic['flag'] == 'unchanged') return;
      const action = this.graphics.some(s => s.id === graphic.id) ? 'edición' : 'creación';
      graphic.idtier3 = this.idtier3Selected;
      this.utilLogservice.createLog(graphic, action, 'graficos');
    });
  }
  //Manejo de los logs referencias
  handleBibliosLog(updatedBiblios: Biblio[]): void {
    updatedBiblios.forEach(biblio => {
      if (biblio && biblio['flag'] == 'unchanged') return;
      const action = this.biblios.some(s => s.id === biblio.id) ? 'edición' : 'creación';
      biblio.idtier3 = this.idtier3Selected;
      this.utilLogservice.createLog(biblio, action, 'bibliografia');
    });
  }

  normalizeContentBiblio(value: any): string {
    if (!value) return '';
    return value
      .normalize('NFC')
      .replace(/\s+/g, ' ')
      .replace(/\u200B/g, '')
      .replace(/\[\d+\]\s*/g, (match) => match.trim())
      .trim();
  }

  normalizeValue(value: any): string {
    return value ? value.toString().trim() : '';
  }

  async getIsBlockedTier3(id: number): Promise<boolean> {
    try {
      const res = await firstValueFrom(this.tier3.idT3blocked(id));
      return res['isBlocked'];
    } catch (err) {
      console.error('Error al verificar si está bloqueado:', err);
      throw new Error('No se pudo verificar si el documento está bloqueado.');
    }
  }
}
